/**
 * #72 + #75 共通: ジョブ追跡関連の絶対上限時間。
 * score-engine `JobManager.JOB_TTL` (30 分) と一致させる。
 *
 * 利用箇所:
 * - useJobLifecycleResume.MAX_TOTAL_PROCESSING_MS (#72): polling 中の watchdog
 * - useJobLifecycleResume.STALE_ENTRY_THRESHOLD_MS (#75): mount 時 / visibility 時の同期 stale 判定
 *
 * 値を変える場合は server 側の JOB_TTL も合わせて確認する。
 */
export const JOB_LIFECYCLE_TIMEOUT_MS = 30 * 60_000;
